import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const eventsApi = createApi({
  reducerPath: 'eventsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getEvents: builder.query({
      query: () => {
        return {
          url: urls.foEvents,
        };
      },
    }),
    getArchivedEvents: builder.query({
      query: () => {
        return {
          url: urls.foArchivedEvents,
        };
      },
    }),
    getNonArchivedEvents: builder.query({
      query: () => {
        return {
          url: urls.foNonArchivedEvents,
        };
      },
    }),
    getEvent: builder.query({
      query: (id) => ({
        url: urls.foEventDetail(id),
      }),
    }),
    saveArchivation: builder.mutation({
      query({ id }) {
        return {
          url: urls.foEventArchivation(id),
          method: 'POST',
        };
      },
    }),
    saveRestoreCopy: builder.mutation({
      query({ id, body }) {
        return {
          url: urls.foEventRestoreCopy(id),
          method: 'POST',
          data: body,
        };
      },
    }),
    saveEvent: builder.mutation({
      query({ id, body }) {
        if (id) {
          return {
            url: urls.foEventDetail(id),
            method: 'PUT',
            data: body,
          };
        } else {
          return {
            url: urls.foEvents,
            method: 'POST',
            data: body,
          };
        }
      },
    }),
    deleteEvent: builder.mutation({
      query(id) {
        return {
          url: urls.foEventDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetNonArchivedEventsQuery,
  useGetArchivedEventsQuery,
  useGetEventQuery,
  useSaveArchivationMutation,
  useSaveRestoreCopyMutation,
  useSaveEventMutation,
  useDeleteEventMutation,
} = eventsApi;
